import urls, { apiBase } from './restConstants';

const getSentryConfig = () => (
  fetch(apiBase + '/' + urls.config, { credentials: 'same-origin' })
);
export default getSentryConfig;



// WEBPACK FOOTER //
// ./shared/src/rest/configurationRest.js